import React from "react";
import CheckBoxActive from "./checkBoxActive";
import CheckBoxCompleted from "./checkBoxCompleted";
import CheckBoxCanceled from "./checkBoxCanceled";
import CheckBoxFree from "./checkBoxFree";
import CheckBoxMissed from "./checkBoxMissed";
import { Box } from "@mui/material";
import CheckBoxSpeedcoaching from "./checkBoxSpeedcoaching";

const FilterCheckboxes = (): React.JSX.Element => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexWrap: "wrap",
    }}
  >
    <CheckBoxActive />
    <CheckBoxCompleted />
    <CheckBoxFree />
    <CheckBoxMissed />
    <CheckBoxCanceled />
    <CheckBoxSpeedcoaching />
  </Box>
);

export default FilterCheckboxes;
